import { Box, Grid, Card, styled, CardContent } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Chart from "react-apexcharts";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import API from "../../../api";
import CircularIndeterminate from "../../../components/circularProgress";

const StyledCard = styled(Card)`
  flex: 1;
  width: auto;
  background-color: #1E1E1E;
  background-image: none;
  border-radius: 15px;
  /* border: 3px solid #449095; */
`;

const TiresiaEntropy = ({ customerName }) => {
    const [, setOptions] = useState({});
    const [series, setSeries] = useState([]);
    const [, setSeriesRadar] = useState([]);
    const [entropyT, setEntropyT] = useState([]);
    const [categoriesRadar, setCategoriesRadar] = useState([]);
    const [charged, setCharged] = useState(false)
    const [chargedT, setChargedT] = useState(false)

    if (!customerName && window.sessionStorage.getItem("type") === "reseller") {
        window.sessionStorage.setItem("selectedTab", "Dashboard");
        setTimeout(function checkCondition() {
            if (window.sessionStorage.getItem("selectedTab") === "Dashboard") {
                window.location.href = `/${window.sessionStorage.getItem("type")}/home`;
            } else {
                setTimeout(checkCondition, 500); // Aspetta 1 secondo e poi richiama la funzione
            }
        }, 0);
    }

    useEffect(() => {

        API.getTiresiaEntropy()
            .then((result) => {
                let series_a = [];
                let categories_a = [];
                for (let x = 0; x < result.data.length; x++) {
                    series_a.push({
                        name: result.data[x].cell_id,
                        data: result.data[x].valori,
                    });
                    categories_a = categories_a.concat(result.data[x].datetime);

                    const orari = categories_a.map((datetimeString) => {
                        // Utilizziamo slice() per estrarre i primi 8 caratteri come orario (hh:mm:ss)
                        const timeString = datetimeString.slice(11, 16);
                        return timeString;
                    });
                    setCategoriesRadar(orari);
                }
                const filteredSeries = series_a.map((seriesItem) => ({
                    name: seriesItem.name,
                    data: seriesItem.data.filter((value) => value !== 0),
                }));
                setSeries(filteredSeries);
                setSeriesRadar([
                    {
                        chart: filteredSeries[0].name,
                        series: filteredSeries[0].data
                    },
                    {
                        chart: filteredSeries[1].name,
                        series: filteredSeries[1].data
                    },
                    {
                        chart: filteredSeries[2].name,
                        series: filteredSeries[2].data
                    }
                ])

                let opzioni = {
                    chart: {
                        height: "100%",
                        width: '100%',
                        type: "line",
                        toolbar: {
                            show: true,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false,
                            },
                            export: {
                                csv: {
                                    filename: "TiresiaEntropy",
                                    columnDelimiter: ",",
                                    headerCategory: "category",
                                    headerValue: "value",
                                    dateFormatter(timestamp) {
                                        return new Date(timestamp).toDateString();
                                    },
                                },
                                svg: {
                                    filename: "TiresiaEntropy",
                                },
                                png: {
                                    filename: "TiresiaEntropy",
                                },
                            },
                            autoSelected: "zoom",
                        },
                    },
                    grid: {
                        show: false,
                    },
                    stroke: {
                        curve: "smooth",
                        width: 1.5,
                    },
                    legend: {
                        show: true,
                        position: "top",
                    },
                    series: series_a,
                    markers: {
                        size: 3.5,
                        colors: ["#D1C166", "#008b8b", "#3E4496"],
                        strokeWidth: 0.5,
                        shape: "circle",
                    },
                    colors: ["#D1C166", "#008b8b", '#3E4496'],
                    xaxis: {
                        categories: categories_a,
                        title: {
                            text: "Date (UTC +1)",
                        },
                        type: "datetime",
                        tickAmount: 8,
                        tooltip: {
                            enabled: false,
                        },
                    },
                    yaxis: {
                        title: {
                            text: "Log",
                        },
                        fill: {
                            colors: ["#fff"],
                        },
                    },
                    tooltip: {
                        intersect: true,
                        shared: false,
                    },
                };
                setCharged(true);
                setOptions(opzioni);
            })
            .catch((error) => {
                console.error(
                    "Si è verificato un errore durante il recupero dei dati",
                    error
                );
                setCharged(true);
            });

        API.getTiresiaEntropyTable()
            .then((result) => {
                const transformedData = result.data.map((item) => ({
                    id: item._id,
                    ...item,
                }))
                setEntropyT(transformedData);
                setChargedT(true);
            })
            .catch((error) => {
                console.error('Si è verificato un errore durante il recupero dei dati', error);
                setChargedT(true);
            });
    }, []);


    const columns = [
        { field: '_id', headerName: 'TYPE', minWidth: 55, flex: 1, headerAlign: "center", align: "center", cellClassName: "scrollableCell", },
        { field: 'timestampMinimo', headerName: 'MIN TIME (UTC +1)', minWidth: 121, flex: 1, headerAlign: "center", align: "center", cellClassName: "scrollableCell", },
        { field: 'timestampMassimo', headerName: 'MAX TIME (UTC +1)', minWidth: 121, flex: 1, headerAlign: "center", align: "center", cellClassName: "scrollableCell", },
        { field: 'valoreMassimo', headerName: 'MAX VALUE', minWidth: 130, flex: 1, headerAlign: "center", align: "center", cellClassName: "scrollableCell", },
    ]


    var optionsr = {
        chart: {
            height: 350,
            type: 'radar',
            dropShadow: {
                enabled: true,
                blur: 0,
                left: 1,
                top: 1
            },
        },
        stroke: {
            width: 2
        },
        fill: {
            opacity: 0.3
        },
        markers: {
            size: 4
        },
        yaxis: {
            show: false
        },
        xaxis: {
            categories: categoriesRadar,
        }
    };


    return (
        <Box m="20px">
            <Grid container spacing={2}>
                <Grid xs={12} md={12}>
                    <Header
                        title="Tiresia Entropy"
                        subtitle=""
                        desc={`
                        The entropy of a random variable is the average level of "information", "surprise", or "uncertainty" inherent to the variable's possible outcomes.
                        The core idea of information theory is that the "informational value" of a communicated message depends on the degree to which the content of the message is surprising.
                        If a highly likely event occurs, the message carries very little information.
                        On the other hand, if a highly unlikely event occurs, the message is much more informative.
                        In this case the entropy measures the average level of the number of transmitted packets every 10 minutes.
                        If this number is constant the value of entropy is 0 which means that the network is in a stable state. Value of entropy major than 1 means that the network is less stable because the number of packets is more variable.
                      `}
                    />

                    {series.length === 0 ? (<Box
                        display='flex'
                        justifyContent='center'
                        alignItems='center'
                        height='100%'>
                        <CircularIndeterminate charged={charged} title="No Data for the graph" />
                    </Box>

                    ) : (
                        <Box className='graphEntropy'>
                            <StyledCard>
                                <CardContent>
                                    <Chart
                                        id="chartGlobal"
                                        cellClassName="prova"
                                        options={optionsr}
                                        series={series}
                                        type="radar"
                                    />
                                </CardContent>
                            </StyledCard>
                        </Box>)}
                </Grid>
                <Grid marginTop={3} xs={12} md={12}>
                    <Box
                        m="0 0 0 0"
                        height="27vh"
                    >
                        <DataGrid
                            sx={{
                                fontWeight: 900,
                                height: "100%",
                                width: "100%",
                                borderRadius: 5,
                                border: "solid 1px #459095",
                                overflowX: "auto",
                                "& .MuiDataGrid-root": {
                                    border: "none",
                                    backgroundColor: "transparent !important"
                                },
                                "& .MuiDataGrid-cell": {
                                    borderBottom: "none",
                                },
                                "& .name-column--cell": {
                                    color: "#1D7B91",
                                    fontWeight: 900
                                },
                                "& .MuiDataGrid-toolbarContainer": {
                                    borderTopRightRadius: 17,
                                    borderTopLeftRadius: 17,
                                    gap: 4,
                                    backgroundColor: "#449095",
                                    color: "#1D7B91",
                                },
                                "& .MuiDataGrid-footerContainer": {
                                    borderTop: "none",
                                    backgroundColor: "#449095",
                                    borderBottomLeftRadius: 20,
                                    borderBottomRightRadius: 20
                                },
                                "& .MuiCheckbox-root": {
                                    color: "#1D7B91 !important",
                                },
                                "& .MuiButtonBase-root": {
                                    color: "#fff !important",
                                },
                                "& .MuiCircularProgress-root": {
                                    color: "#5b9ba9 !important"
                                },
                                "& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell": {
                                    whiteSpace: "normal !important"
                                },
                                "& .MuiBadge-badge": {
                                    backgroundColor: '#dd8d16'
                                },
                                "& .MuiDataGrid-root .MuiDataGrid-container--bottom [role=row]": {
                                    background: "#D0D0D0 !important"
                                },
                                "& .MuiDataGrid-panelWrapper": {
                                    width: '600px !important'
                                },
                                "& .MuiDataGrid-overlayWrapperInner": {
                                    backgroundColor: '#1a1a1a !important'
                                },
                                "& .MuiDataGrid-virtualScrollerContent": {
                                    backgroundColor: '#1a1a1a !important'
                                },
                                "& .MuiDataGrid-filler": {
                                    backgroundColor: '#1a1a1a !important'
                                },
                                "& .MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: 900
                                },
                                "& .MuiDataGrid-virtualScroller": {
                                    borderRadius: 0
                                },
                                "& .MuiDataGrid-columnHeader": {
                                    backgroundColor: "#449095",
                                },
                            }}
                            className="tableEntropy" hideFooter={true} loading={!chargedT} rows={entropyT} columns={columns} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TiresiaEntropy;
